<template>
  <div class="details deals__container deals__container--active">
    <div class="details-filter">
      <div class="filters">
        <form class="form" id="details-form">
          <div class="form-block form-block--25">
            <input type="text" @keydown.enter="() => applyFilters()" v-model="requestDTO.query" :placeholder="$t('labels.sanitized_requisite')" class="form-control">
          </div>

          <div class="form-block form-block--25">
            <Multiselect id="currencies"
                         class="multiselect-sm"
                         v-model="requestDTO.currencies"
                         :options="currencyList"
                         :custom-label="(opt) => `${opt}`"
                         :multiple="true"
                         select-label="Select"
                         :placeholder="$t('labels.currencies')"
            >
            </Multiselect>
          </div>
          <div class="form-block form-block--25">
            <Multiselect id="methods"
                         class="multiselect-sm"
                         v-model="requestDTO.methods"
                         :options="methodList()"
                         :custom-label="(opt) => helper.trans(`pay_methods.${opt}`)"
                         :multiple="true"
                         select-label="Select"
                         :placeholder="helper.trans('labels.payment_methods')"
            >
              <template #option="props">
                <div class="pay-method">
                  <PayMethodIcon icon-class="icon" :method="props.option"></PayMethodIcon>
                  <span class="overflow-hidden" style="white-space: nowrap; text-overflow: ellipsis">{{ helper.trans('pay_methods.' + props.option) }}</span>
                </div>
              </template>
            </Multiselect>
          </div>
          <div class="form-block form-block--25">
            <Multiselect id="options"
                         class="multiselect-sm"
                         v-model="requestDTO.options"
                         :options="store.getters['currencyMethods/options']()"
                         :custom-label="(opt) => helper.trans(`payment_options.${opt}`)"
                         :multiple="true"
                         select-label="Select"
                         :placeholder="helper.trans('labels.payment_options')"
            >
            </Multiselect>
          </div>
          <div class="form-block form-block--25">
            <Multiselect id="statused"
                         class="multiselect-sm"
                         v-model="requestDTO.statuses"
                         :options="[1, 0]"
                         :custom-label="(opt) => opt === 1 ? helper.trans('requisites.active') : helper.trans('requisites.inactive')"
                         :multiple="true"
                         select-label="Select"
                         :placeholder="helper.trans('labels.status')"
            >
            </Multiselect>
          </div>
          <div class="form-block form-block--25">
            <Multiselect id="group"
                         class="multiselect-sm"
                         v-model="requestDTO.groupId"
                         :options="store.getters['reqGroups/ids']"
                         :custom-label="(opt) => store.getters['reqGroups/get'](opt)?.name"
                         :multiple="false"
                         select-label="Select"
                         :placeholder="$t('labels.req_group')"
            >
            </Multiselect>
          </div>
          <div class="form-block form-block--25">
            <Multiselect id="device"
                         class="multiselect-sm"
                         v-model="requestDTO.deviceId"
                         :options="store.getters['devices/ids']"
                         :custom-label="(opt) => store.getters['devices/get'](opt)?.name"
                         :multiple="false"
                         select-label="Select"
                         :placeholder="$t('labels.device')"
            >
            </Multiselect>
          </div>
          <div class="form__controls">
            <LoaderButton :on-click="applyFilters" class="form__btn btn">
              <span class="text-capitalize-first">{{$t('button.apply')}}</span>
            </LoaderButton>
            <LoaderButton :on-click="clearFilters" class="form__btn form__btn--reset btn btn--2">
              <span class="text-capitalize-first">{{$t('button.reset')}}</span>
            </LoaderButton>
          </div>
        </form>
      </div>
    </div>


    <div class="details__controls">
      <a href="#" @click.prevent="showDevices()" class="form__btn form__btn--reset btn btn--2">
        <span class="text-capitalize-first">{{ $t('labels.devices')}}</span>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 16.25C8 16.0511 8.07902 15.8603 8.21967 15.7197C8.36032 15.579 8.55109 15.5 8.75 15.5H11.25C11.4489 15.5 11.6397 15.579 11.7803 15.7197C11.921 15.8603 12 16.0511 12 16.25C12 16.4489 11.921 16.6397 11.7803 16.7803C11.6397 16.921 11.4489 17 11.25 17H8.75C8.55109 17 8.36032 16.921 8.21967 16.7803C8.07902 16.6397 8 16.4489 8 16.25Z"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M4 4C4 3.20435 4.31607 2.44129 4.87868 1.87868C5.44129 1.31607 6.20435 1 7 1H13C13.7956 1 14.5587 1.31607 15.1213 1.87868C15.6839 2.44129 16 3.20435 16 4V16C16 16.7956 15.6839 17.5587 15.1213 18.1213C14.5587 18.6839 13.7956 19 13 19H7C6.20435 19 5.44129 18.6839 4.87868 18.1213C4.31607 17.5587 4 16.7956 4 16V4ZM8 2.5V3.25C8 3.664 8.336 4 8.75 4H11.25C11.4489 4 11.6397 3.92098 11.7803 3.78033C11.921 3.63968 12 3.44891 12 3.25V2.5H13C13.3978 2.5 13.7794 2.65804 14.0607 2.93934C14.342 3.22064 14.5 3.60218 14.5 4V16C14.5 16.3978 14.342 16.7794 14.0607 17.0607C13.7794 17.342 13.3978 17.5 13 17.5H7C6.60218 17.5 6.22064 17.342 5.93934 17.0607C5.65804 16.7794 5.5 16.3978 5.5 16V4C5.5 3.60218 5.65804 3.22064 5.93934 2.93934C6.22064 2.65804 6.60218 2.5 7 2.5H8Z"  />
        </svg>
      </a>
      <a href="#" @click.prevent="showGroups()" class="form__btn form__btn--reset btn btn--2">
        <span class="text-capitalize-first">{{$t('button.groups')}}</span>
      </a>
      <a href="#" @click.prevent="showLimits()" class="form__btn form__btn--reset btn btn--2">
        <span class="text-capitalize-first limits-label">{{$t('button.limits')}}
          <span v-if="hasUnfinishedPlans" class="limits-dot" aria-hidden="true"></span>
        </span>
      </a>
      <a v-if="templatesAvailable" href="#" @click.prevent="showTemplates()" class="form__btn form__btn--reset btn btn--2">
        <span class="text-capitalize-first">{{ $t('requisites.templates.button') }}</span>
      </a>
      <a @click.prevent="showEditForm()" href="#" class="form__btn form__btn--reset btn btn--2 ">
        <span class="text-capitalize-first">{{ $t('button.create') }}</span>
      </a>
    </div>

    <LoaderContent ref="loader">
    <div class="mb-2 d-flex align-items-center flex-wrap" style="gap: 12px">
      <div class="form__btn form__btn--reset btn btn--2 requisites-per-page">
        <span class="text-capitalize-first">{{ $t('labels.show') }}</span>
        <select
          v-model.number="requisites.limit"
          class="requisites-per-page__select"
          @change="page = 1; load()"
        >
          <option v-for="opt in perPageOptions" :key="opt" :value="opt">{{ opt }}</option>
        </select>
        <span class="text-capitalize-first">{{ $t('labels.records') }}</span>
      </div>
      <a href="#" @click.prevent="toggleGroupByPhone" class="form__btn form__btn--reset btn btn--2" :class="{'btn--accept': groupByPhone}">
        <span class="text-capitalize-first">{{ $t('requisites.group_by_phone') }}</span>
      </a>
      <template v-if="bulkEditAvailable">
        <label class="d-flex align-items-center gap-2 mb-0">
          <input type="checkbox" class="form-check-input mt-0" :checked="allVisibleSelected" @change="selectAllVisible($event.target.checked)">
          <span class="text-capitalize-first">{{ $t('requisites.select_all_page') }}</span>
        </label>
        <a v-if="selectedItems.length > 0" href="#" @click.prevent="showBulkEdit" class="form__btn form__btn--reset btn btn--2">
          <span class="text-capitalize-first">{{ $t('requisites.bulk_edit_selected', {count: selectedItems.length}) }}</span>
        </a>
      </template>
      <template v-if="groupByPhone">
        <a v-if="selectedInactiveItems.length > 0" href="#" @click.prevent="enableSelected" class="form__btn form__btn--reset btn btn--2">
          <span class="text-capitalize-first">{{ $t('requisites.enable_selected', {count: selectedInactiveItems.length}) }}</span>
        </a>
        <a v-if="selectedActiveItems.length > 0" href="#" @click.prevent="disableSelected" class="form__btn form__btn--reset btn btn--2">
          <span class="text-capitalize-first">{{ $t('requisites.disable_selected', {count: selectedActiveItems.length}) }}</span>
        </a>
      </template>
    </div>
    <div v-if="hasFrozenRequisites" class="d-flex flex-wrap gap-3 requisites-legend">
      <span v-for="status in ['free', 'in_progress', 'near_limit', 'limit', 'inactive']" :key="status" class="d-inline-flex align-items-center gap-1">
        <span class="requisite-status-dot" :class="'requisite-status-dot--' + status"></span>{{ helper.trans('requisites.status_' + status) }}
      </span>
    </div>
    <div style="overflow: auto">
    <table class="table table__flex" style="position: relative">
      <thead>
      <tr>
        <th v-if="!groupByPhone && reorderEnabled" class="requisites-drag-cell"></th>
        <th style="text-align: left"><span class="text-capitalize-first">{{ $t('labels.requisites')}}</span></th>
        <th style="width: 0"><span class="text-capitalize-first">{{ $t('labels.device')}}</span></th>
        <th style="width: 0"><span class="text-capitalize-first">{{ $t('labels.req_group')}}</span></th>
        <th style=""><span class="text-capitalize-first">{{ $t('labels.sum_limits')}}</span></th>
        <th style=""><span class="text-capitalize-first">{{ $t('labels.volume_limits')}}</span></th>
        <th style=""><span class="text-capitalize-first">{{ $t('labels.count_limits')}}</span></th>
        <th style=""><span class="text-capitalize-first">{{ $t('labels.concurrent_trader_count_short')}}</span></th>
        <th style=""><span class="text-capitalize-first">{{ $t('labels.status')}}</span></th>
        <th></th>
      </tr>
      </thead>
      <tbody v-if="groupByPhone">
      <template v-for="group in groups" :key="group.key ?? group.items[0].id">
        <RequisitesPhoneGroupRow
          v-if="group.key !== null"
          :group="group"
          :expanded="isExpanded(group)"
          :selected-count="selectedCountInGroup(group)"
          @toggleExpand="toggleExpand(group)"
          @select="checked => selectGroup(group, checked)"
        ></RequisitesPhoneGroupRow>
        <RequisiteRow
          v-if="group.key === null"
          :item="group.items[0]"
          selectable
          :selected="isSelected(group.items[0].id)"
          @select="checked => toggleSelect(group.items[0], checked)"
          @toggle="toggleRequisitesActivity"
          @showLogs="showLogs"
          @fraudexFeedback="showFraudexFeedbackModal"
          @edit="showEditForm"
          @remove="deleteRequisites"
        ></RequisiteRow>
        <template v-if="group.key !== null && isExpanded(group)">
          <RequisiteRow
            v-for="item in group.items"
            :key="item.id"
            :item="item"
            child
            selectable
            :selected="isSelected(item.id)"
            @select="checked => toggleSelect(item, checked)"
            @toggle="toggleRequisitesActivity"
            @showLogs="showLogs"
            @fraudexFeedback="showFraudexFeedbackModal"
            @edit="showEditForm"
            @remove="deleteRequisites"
          ></RequisiteRow>
        </template>
      </template>
      </tbody>
      <Sortable
        v-else
        :list="requisites.items"
        item-key="id"
        tag="tbody"
        @end="onRequisitesReorder($event)"
        :options="{draggable: '.draggable', handle: '.drag-handle', forceFallback: true, fallbackOnBody: true, animation: 150, disabled: !reorderEnabled}"
      >
      <template #item="{element: item}">
      <tr class="draggable" :key="item.id">
        <td v-if="reorderEnabled" class="requisites-drag-cell">
          <div class="drag-handle">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="5" cy="3" r="1.25" fill="currentColor"/>
              <circle cx="11" cy="3" r="1.25" fill="currentColor"/>
              <circle cx="5" cy="8" r="1.25" fill="currentColor"/>
              <circle cx="11" cy="8" r="1.25" fill="currentColor"/>
              <circle cx="5" cy="13" r="1.25" fill="currentColor"/>
              <circle cx="11" cy="13" r="1.25" fill="currentColor"/>
            </svg>
          </div>
        </td>
        <td>
          <div class="detail__card card-info" >
            <div class="d-flex align-items-center gap-sm">
              <input v-if="bulkEditAvailable" type="checkbox" class="form-check-input flex-shrink-0" :checked="isSelected(item.id)" @change="toggleSelect(item, $event.target.checked)">
              <div>
                <PayMethodIcon icon-class="pay-method-icon-xl" :method="item.method"></PayMethodIcon>
              </div>
              <div>
                <div class="card-info__title">
                  <span><strong>{{ item.currency }}</strong> {{ $t(`payment_options.${item.paymentOption}`) }}
                <span v-if="item.crossBorderCurrency">{{item.crossBorderCurrency}}</span> <span v-if="item.paymentSystem">{{ helper.trans('payment_systems.' + item.paymentSystem) }}</span>
              </span>

                </div>
                <template v-if="crossBorderSwift(item.raw)">
                  <div class="card-info__name">{{ item.holderName }}</div>
                  <div class="card-info__number">
                    <span>{{ item.requisites }}</span>
                    <RequisiteFillStatusDot v-if="hasFrozenSums(item)" :item="item" class="ms-1"></RequisiteFillStatusDot>
                  </div>
                  <div class="card-info__name">{{ $t('labels.raw_field.swift') }} {{ crossBorderSwift(item.raw) }}</div>
                </template>
                <template v-else>
                <div class="card-info__number d-flex align-items-start gap-1 flex-wrap">
                  <a v-if="item.paymentOption === PaymentOption.SBP_QR && item.requisites?.startsWith('http')" :href="item.requisites" target="_blank">{{ helper.domain(item.requisites) }}</a>
                  <span v-else-if="item.paymentOption === PaymentOption.MANUAL_SBP_QR" class="text-muted">—</span>
                  <a v-else-if="item.paymentOption === PaymentOption.CLICK_UZ_QR && item.requisites.startsWith('http')" :href="item.requisites" target="_blank">{{ helper.trans('labels.my_click_uz') }}</a>
                  <a v-else-if="item.paymentOption === PaymentOption.TIPS && item.requisites.startsWith('http')" :href="item.requisites" target="_blank">{{ helper.domain(item.requisites) }}</a>
                  <template v-else-if="item.paymentOption === PaymentOption.VIET_QR">
                    <span
                      v-b-tooltip.hover
                      class="font-monospace text-break flex-grow-1"
                      style="min-width: 0"
                      :title="vietQrEmvFromRaw(item.raw) || undefined"
                    >{{ truncateVietQrEmvDisplay(vietQrEmvFromRaw(item.raw)) || '—' }}</span>
                    <copy-button v-if="vietQrEmvFromRaw(item.raw)" :value="vietQrEmvFromRaw(item.raw)" class="flex-shrink-0 align-self-center"></copy-button>
                  </template>
                  <template v-else-if="item.paymentOption === PaymentOption.IND_QR">
                    <span
                      v-b-tooltip.hover
                      class="font-monospace text-break flex-grow-1"
                      style="min-width: 0"
                      :title="qrisEmvFromRaw(item.raw) || undefined"
                    >{{ truncateVietQrEmvDisplay(qrisEmvFromRaw(item.raw)) || '—' }}</span>
                    <copy-button v-if="qrisEmvFromRaw(item.raw)" :value="qrisEmvFromRaw(item.raw)" class="flex-shrink-0 align-self-center"></copy-button>
                  </template>
                  <template v-else-if="item.paymentOption === PaymentOption.BR_QR">
                    <span
                      v-b-tooltip.hover
                      class="font-monospace text-break flex-grow-1"
                      style="min-width: 0"
                      :title="pixEmvFromRaw(item.raw) || undefined"
                    >{{ truncateVietQrEmvDisplay(pixEmvFromRaw(item.raw)) || '—' }}</span>
                    <copy-button v-if="pixEmvFromRaw(item.raw)" :value="pixEmvFromRaw(item.raw)" class="flex-shrink-0 align-self-center"></copy-button>
                  </template>
                  <span v-else>{{ item.requisites }}</span>
                  <RequisiteFillStatusDot v-if="hasFrozenSums(item)" :item="item" class="align-self-center ms-1"></RequisiteFillStatusDot>
                </div>
                <div class="card-info__name">
                  {{ item.holderName }}
                </div>
                </template>
              </div>
            </div>

          </div>
        </td>
        <td class="detail__flex">
          <div class="rate-info__mobile-label">{{$t('labels.device')}}</div>
          <span v-if="item.device" class="d-flex">
            <img :src="require(`@/apps/public/assets/img/device-${item.device.status}.svg`)">
            {{ item.device?.name }}
          </span>
        </td>
        <td class="detail__flex">
          <div class="rate-info__mobile-label">{{$t('labels.req_group')}}</div>
          {{ item.group?.name }}
        </td>
        <td class="detail__flex">
          <div class="rate-info__mobile-label">{{$t('labels.sum_limits')}}</div>
          <div class="sum-limits">
            <span v-if="item.minPayInDealSum">{{ helper.trans('labels.from_limit', {sum: numberFormatter.formatNumber(item.minPayInDealSum), currency: item.minPayInDealSum!.currency })}}<ReuseMinCapBadge :item="item"></ReuseMinCapBadge></span>
            <span v-if="item.maxPayInDealSum">{{ helper.trans('labels.to_limit', {sum: numberFormatter.formatNumber(item.maxPayInDealSum), currency: item.maxPayInDealSum!.currency })}}</span>
          </div>
        </td>
        <td>
          <div class="detail__limits">
            <div class="rate-info__mobile-label">{{$t('labels.volume_limits')}}</div>
            <div class="detail__limit">
              <div class="detail__limit-type">{{$t('labels.day')}}</div>
              <div class="detail__limit-container" v-b-tooltip.hover :title="sumTitle('labels.day', item.dayTradesSum, item.dayTradesFrozenSum)">
                <RequisiteSumFill v-if="hasFrozenSums(item)" :total="item.dayTradesSum" :frozen="item.dayTradesFrozenSum" :limit="item.dayTradesSumLimit" :active="item.isActive"></RequisiteSumFill>
                <div v-else class="detail__limit-count" :style="{width: (parseInt(item.dayTradesSum.amount)/parseInt(item.dayTradesSumLimit.amount) * 100) + '%'}" :class="{'bg-attention': isDayLimitReached(item)}"></div>
                <div class="limits-values">
                  {{ numberFormatter.formatNumber(item.dayTradesSum) }}/{{ numberFormatter.formatNumber(item.dayTradesSumLimit) }}
                </div>
              </div>
            </div>
            <div class="detail__limit">
              <div class="detail__limit-type">{{$t('labels.month')}}</div>
              <div class="detail__limit-container" v-b-tooltip.hover :title="sumTitle('labels.month', item.monthTradesSum, item.monthTradesFrozenSum)">
                <RequisiteSumFill v-if="hasFrozenSums(item)" :total="item.monthTradesSum" :frozen="item.monthTradesFrozenSum" :limit="item.monthTradesSumLimit" :active="item.isActive"></RequisiteSumFill>
                <div v-else class="detail__limit-count" :style="{width: (parseInt(item.monthTradesSum.amount)/parseInt(item.monthTradesSumLimit.amount) * 100) + '%'}" :class="{'bg-attention': isMonthLimitReached(item)}"></div>
                <div class="limits-values">
                  {{ numberFormatter.formatNumber(item.monthTradesSum) }}/{{ numberFormatter.formatNumber(item.monthTradesSumLimit) }}
                </div>
              </div>
            </div>
          </div>
        </td>
        <td>
          <div class="detail__limits count-limits">
            <div class="rate-info__mobile-label">{{$t('labels.count_limits')}}</div>
            <div class="detail__limit">
              <div class="detail__limit-type">{{$t('labels.day')}}</div>
              <div class="detail__limit-container" v-b-tooltip.hover :title="$t('labels.day')">
                <div class="detail__limit-count" :style="{width: (item.dayTradesCountLimit === 0 ? 0 : parseInt(item.dayTradesCount)/parseInt(item.dayTradesCountLimit) * 100) + '%'}" :class="{'bg-attention': item.dayTradesCountLimit > 0 && item.dayTradesCount/item.dayTradesCountLimit >= 0.9}"></div>
                <div class="limits-values">
                  {{ numberFormatter.formatNumber(item.dayTradesCount) }}/{{ numberFormatter.formatNumber(item.dayTradesCountLimit) }}
                </div>
              </div>
            </div>
            <div class="detail__limit">
              <div class="detail__limit-type">{{$t('labels.month')}}</div>
              <div class="detail__limit-container" v-b-tooltip.hover :title="$t('labels.month')">
                <div class="detail__limit-count" :style="{width: (item.monthTradesCountLimit === 0 ? 0 : parseInt(item.monthTradesCount)/parseInt(item.monthTradesCountLimit) * 100) + '%'}" :class="{'bg-attention': item.monthTradesCountLimit > 0 && item.monthTradesCount/item.monthTradesCountLimit >= 0.9}"></div>
                <div class="limits-values">
                  {{ numberFormatter.formatNumber(item.monthTradesCount) }}/{{ numberFormatter.formatNumber(item.monthTradesCountLimit) }}
                </div>
              </div>
            </div>
          </div>
        </td>
        <td class="detail__flex">
          <div class="rate-info__mobile-label">{{$t('labels.concurrent_trader_count_short')}}</div>
          <span v-if="item.concurrentTradesCount">{{ numberFormatter.formatNumber(item.concurrentTradesCount) }}</span>
        </td>
        <td class="detail__flex">
          <div class="rate-info__mobile-label">
            {{ $t('labels.status') }}
          </div>
          <div class="switcher">
            <label class="switch">
              <input type="checkbox" v-b-tooltip.hover :title="item.isActive ? helper.trans('requisites.active') : helper.trans('requisites.inactive')" v-model="item.isActive" @change="toggleRequisitesActivity($event, item)">
              <span class="slider"></span>
            </label>
          </div>
        </td>
        <td>
          <div class="detail__controls" style="">
            <a v-if="item.device" href="#" @click.prevent="showLogs(item.device)" class="btn detail__btn">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.505 2.365C5.32653 2.12142 7.16226 1.99948 9 2C10.863 2 12.697 2.124 14.495 2.365C15.742 2.532 16.675 3.473 16.93 4.633C16.7394 4.59745 16.5466 4.57441 16.353 4.564C14.7855 4.47838 13.2145 4.47838 11.647 4.564C9.229 4.696 7.5 6.727 7.5 8.998V11.238C7.5 12.651 8.17 13.973 9.26 14.8L6.28 17.78C6.17511 17.8848 6.04153 17.9561 5.89614 17.985C5.75074 18.0139 5.60004 17.999 5.46308 17.9423C5.32611 17.8856 5.20903 17.7895 5.12661 17.6663C5.04419 17.5431 5.00013 17.3982 5 17.25V13.807C4.499 13.759 4 13.701 3.505 13.635C2.033 13.438 1 12.162 1 10.72V5.28C1 3.839 2.033 2.562 3.505 2.365Z" fill="#F7F9FC"></path>
                <path d="M14 6C13.238 6 12.48 6.02 11.729 6.062C10.157 6.148 9 7.472 9 8.998V11.238C9 12.757 10.147 14.077 11.71 14.173C11.924 14.186 12.138 14.197 12.352 14.207C12.552 14.216 12.737 14.297 12.87 14.431L15.22 16.781C15.3249 16.8858 15.4586 16.9572 15.6041 16.986C15.7496 17.0149 15.9004 16.9999 16.0374 16.9431C16.1744 16.8863 16.2915 16.7901 16.3738 16.6667C16.4562 16.5433 16.5001 16.3983 16.5 16.25V14.18C17.953 13.985 19 12.717 19 11.265V8.998C19 7.472 17.843 6.148 16.271 6.062C15.5147 6.02068 14.7574 6.00001 14 6Z" fill="#F7F9FC"></path>
              </svg>
            </a>
            <a v-if="item.isWhiteTriangle && store.getters.getAppData?.fraudexEnabled" href="#" @click.prevent="showFraudexFeedbackModal(item)" v-b-tooltip.hover :title="$t('fraudex.leave_feedback')" class="btn detail__btn">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 2C1.44772 2 1 2.44772 1 3V13C1 13.5523 1.44772 14 2 14H4V17.5858C4 17.851 4.10536 18.1054 4.29289 18.2929L7.70711 21.7071C7.89464 21.8946 8.149 22 8.41421 22H18C18.5523 22 19 21.5523 19 21V3C19 2.44772 18.5523 2 18 2H2Z" fill="#F7F9FC"/>
                <path d="M5 7C5 6.44772 5.44772 6 6 6H14C14.5523 6 15 6.44772 15 7C15 7.55228 14.5523 8 14 8H6C5.44772 8 5 7.55228 5 7Z" fill="white"/>
                <path d="M5 10C5 9.44772 5.44772 9 6 9H11C11.5523 9 12 9.44772 12 10C12 10.5523 11.5523 11 11 11H6C5.44772 11 5 10.5523 5 10Z" fill="white"/>
              </svg>
              <span>{{ $t('fraudex.leave_feedback') }}</span>
            </a>
            <a href="#" @click.prevent="showEditForm(item)" class="btn detail__btn detail__redact">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.43302 17.9172L2.69502 14.7622C2.89605 14.2592 3.19714 13.8023 3.58002 13.4192L13.9898 3.01046L16.9903 6.01046L6.58102 16.4192C6.19799 16.8025 5.74108 17.1039 5.23802 17.3052L2.08302 18.5672C1.99216 18.6036 1.89262 18.6125 1.79674 18.5928C1.70087 18.5731 1.61287 18.5258 1.54366 18.4566C1.47446 18.3874 1.42708 18.2994 1.40742 18.2035C1.38775 18.1076 1.39665 18.0081 1.43302 17.9172Z" fill="#F7F9FC"></path>
                <path d="M18.1213 4.0012C18.1213 4.56381 17.8978 5.10338 17.5 5.5012L14.5 2.5012C14.8978 2.10338 15.4374 1.87988 16 1.87988C16.5626 1.87988 17.1022 2.10338 17.5 2.5012C17.8978 2.89903 18.1213 3.43859 18.1213 4.0012Z" fill="#F7F9FC"></path>
              </svg>
            </a>
            <a href="#" @click.prevent="deleteRequisites(item)" class="btn detail__btn detail__remove">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 3C1.73478 3 1.48043 3.10536 1.29289 3.29289C1.10536 3.48043 1 3.73478 1 4V5C1 5.26522 1.10536 5.51957 1.29289 5.70711C1.48043 5.89464 1.73478 6 2 6H18C18.2652 6 18.5196 5.89464 18.7071 5.70711C18.8946 5.51957 19 5.26522 19 5V4C19 3.73478 18.8946 3.48043 18.7071 3.29289C18.5196 3.10536 18.2652 3 18 3H2Z" fill="#F7F9FC"></path>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M2 7.5H18L17.189 15.21C17.1371 15.7015 16.905 16.1564 16.5376 16.487C16.1701 16.8175 15.6933 17.0003 15.199 17H4.802C4.30774 17.0003 3.8309 16.8175 3.46343 16.487C3.09596 16.1564 2.8639 15.7015 2.812 15.21L2 7.5ZM7.22 9.22C7.36063 9.07955 7.55125 9.00066 7.75 9.00066C7.94875 9.00066 8.13937 9.07955 8.28 9.22L10 10.94L11.72 9.22C11.7887 9.14631 11.8715 9.08721 11.9635 9.04622C12.0555 9.00523 12.1548 8.98318 12.2555 8.98141C12.3562 8.97963 12.4562 8.99816 12.5496 9.03588C12.643 9.0736 12.7278 9.12974 12.799 9.20096C12.8703 9.27218 12.9264 9.35701 12.9641 9.4504C13.0018 9.54379 13.0204 9.64382 13.0186 9.74452C13.0168 9.84522 12.9948 9.94454 12.9538 10.0365C12.9128 10.1285 12.8537 10.2113 12.78 10.28L11.06 12L12.78 13.72C12.8537 13.7887 12.9128 13.8715 12.9538 13.9635C12.9948 14.0555 13.0168 14.1548 13.0186 14.2555C13.0204 14.3562 13.0018 14.4562 12.9641 14.5496C12.9264 14.643 12.8703 14.7278 12.799 14.799C12.7278 14.8703 12.643 14.9264 12.5496 14.9641C12.4562 15.0018 12.3562 15.0204 12.2555 15.0186C12.1548 15.0168 12.0555 14.9948 11.9635 14.9538C11.8715 14.9128 11.7887 14.8537 11.72 14.78L10 13.06L8.28 14.78C8.13783 14.9125 7.94978 14.9846 7.75548 14.9812C7.56118 14.9777 7.37579 14.899 7.23838 14.7616C7.10097 14.6242 7.02225 14.4388 7.01883 14.2445C7.0154 14.0502 7.08752 13.8622 7.22 13.72L8.94 12L7.22 10.28C7.07955 10.1394 7.00066 9.94875 7.00066 9.75C7.00066 9.55125 7.07955 9.36063 7.22 9.22Z" fill="#F7F9FC"></path>
              </svg>
            </a>
          </div>
        </td>
      </tr>
      </template>
      </Sortable>
    </table>
    </div>

    <b-pagination
      v-if="requisites.totalCount > (groupByPhone ? groups.length : requisites.items.length)"
      style="    margin-top: 40px;"
      v-model="page"
      :total-rows="requisites.totalCount"
      :per-page="requisites.limit"
      :limit="20"
      @update:modelValue="load()"
      :prev-text="$t('button.back')"
      :next-text="$t('button.next')"
      align="start"
      first-number
      hide-goto-end-buttons
      hide-ellipsis
    ></b-pagination>
    </LoaderContent>

    <ConfirmPopup ref="confirmPopup"></ConfirmPopup>
    <RequisiteTemplatesPopup v-if="templatesAvailable" ref="templatesPopup" @create="createTemplate" @edit="editTemplate"></RequisiteTemplatesPopup>
    <RequisiteFormPopup ref="requisitePopup" @updated="handleRequisiteUpdated" @template-saved="onTemplateSaved" @show-counterparties="showCounterpartiesModal"></RequisiteFormPopup>
    <CounterpartiesPopup ref="counterpartiesModal"></CounterpartiesPopup>
    <BlacklistMethodAgreementPopup @state:updated="onBlackListModalUpdated($event)" @bulk:updated="onBulkAgreementUpdated($event)" ref="agreementPopup"></BlacklistMethodAgreementPopup>
    <RequisitesGroupsPopup ref="requisitesGroupsPopup"></RequisitesGroupsPopup>
    <DevicesPopup ref="devicesPopup"></DevicesPopup>
    <DeviceLogsPopup ref="deviceLogsPopup"></DeviceLogsPopup>
    <LimitsPopup ref="limitsPopup"></LimitsPopup>
    <RequisitesBulkEditPopup ref="bulkEditPopup" @updated="onBulkEdited"></RequisitesBulkEditPopup>
    <FraudexCheckPopup
      v-if="store.getters.getAppData?.fraudexEnabled"
      ref="fraudexCheckPopup"
      :fraudex-check="fraudexCheckData?.fraudexCheck || null"
      @continue="handleFraudexCheckContinue"
      @cancel="handleFraudexCheckCancel"
    ></FraudexCheckPopup>
    <FraudexFeedbackPopup
      v-if="store.getters.getAppData?.fraudexEnabled"
      ref="fraudexFeedbackPopup"
      :requisite="fraudexFeedbackRequisite?.requisites || ''"
      @submit="handleFraudexFeedbackSubmit"
    ></FraudexFeedbackPopup>

  </div>

</template>
<script lang="ts">
import {defineComponent, toRefs, reactive, onMounted, onUnmounted, ref, computed} from 'vue'
import {$t, helper} from "@/service/CommonHelper";
import {useStore} from "vuex";
import {useNotification} from "@kyvg/vue3-notification";
import {TgNotification} from "@/models/enum/TgNotification";
import {api} from "@/service/APIClient";
import Multiselect from "vue-multiselect";
import moment from "moment/moment";
import LoaderButton from "@/apps/public/components/LoaderButton.vue";
import TraderRequisitesDTO from "@/models/TraderRequisitesDTO";
import RequisitesRequestDTO from "@/models/request/RequisitesRequestDTO";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import {Dictionary} from "@/types";
import TraderRequisiteGroupDTO from "@/models/TraderRequisiteGroupDTO";
import TraderDeviceDTO from "@/models/TraderDeviceDTO";
import PaginationDTO from "@/models/PaginationDTO";
import {BPagination} from "bootstrap-vue-3";
import PayMethodIcon from "@/components/PayMethodIcon.vue";
import {PaymentOption} from "@/models/enum/PaymentOption";
import {numberFormatter} from "@/service/NumberFormatter";
import {pixEmvFromRaw, qrisEmvFromRaw, truncateVietQrEmvDisplay, vietQrEmvFromRaw} from "@/service/vietQrRawHelpers";
import {crossBorderSwift} from "@/service/crossBorderSwift";
import CopyButton from "@/apps/public/components/CopyButton.vue";
import RequisiteFormPopup from "@/apps/public/components/RequisiteFormPopup.vue";
import RequisiteTemplatesPopup from "@/apps/public/components/RequisiteTemplatesPopup.vue";
import RequisiteTemplateDTO from "@/models/RequisiteTemplateDTO";
import CounterpartiesPopup from "@/apps/public/components/CounterpartiesPopup.vue";
import BlacklistMethodAgreementPopup from "@/apps/public/components/BlacklistMethodAgreementPopup.vue";
import ConfirmPopup from "@/apps/public/components/ConfirmPopup.vue";
import RequisitesGroupsPopup from "@/apps/public/components/RequisitesGroupsPopup.vue";
import DevicesPopup from "@/apps/public/components/DevicesPopup.vue";
import LoaderContent from "@/apps/public/components/LoaderContent.vue";
import DeviceLogsPopup from "@/apps/public/components/DeviceLogsPopup.vue";
import LimitsPopup from "@/apps/public/components/LimitsPopup.vue";
import FraudexCheckPopup from "@/apps/public/components/FraudexCheckPopup.vue";
import FraudexFeedbackPopup from "@/apps/public/components/FraudexFeedbackPopup.vue";
import RequisiteRow from "@/apps/public/components/RequisiteRow.vue";
import RequisiteSumFill from "@/apps/public/components/RequisiteSumFill.vue";
import RequisiteFillStatusDot from "@/components/RequisiteFillStatusDot.vue";
import ReuseMinCapBadge from "@/apps/public/components/ReuseMinCapBadge.vue";
import {hasFrozenSums, sumTitle} from "@/service/requisiteFrozenSums";
import RequisitesPhoneGroupRow from "@/apps/public/components/RequisitesPhoneGroupRow.vue";
import RequisitesBulkEditPopup from "@/apps/public/components/RequisitesBulkEditPopup.vue";
import RequisitesPhoneGroupDTO from "@/models/RequisitesPhoneGroupDTO";
import BulkToggleRequisitesResponseDTO from "@/models/BulkToggleRequisitesResponseDTO";
import BulkUpdateRequisitesResponseDTO from "@/models/BulkUpdateRequisitesResponseDTO";
import {Sortable} from "sortablejs-vue3";

export default defineComponent({
  methods: {$t},
  components: {
    DeviceLogsPopup,
    LimitsPopup,
    LoaderContent,
    CopyButton,
    DevicesPopup,
    RequisitesGroupsPopup,
    ConfirmPopup,
    BlacklistMethodAgreementPopup,
    RequisiteFormPopup,
    RequisiteTemplatesPopup,
    CounterpartiesPopup,
    PayMethodIcon,
    FraudexCheckPopup,
    FraudexFeedbackPopup,
    LoaderButton,
    Multiselect,
    BPagination,
    RequisiteRow,
    RequisiteSumFill,
    RequisiteFillStatusDot,
    ReuseMinCapBadge,
    RequisitesPhoneGroupRow,
    RequisitesBulkEditPopup,
    Sortable,
  },
  setup() {
    const loader = ref<InstanceType<typeof LoaderContent> | null>(null)
    const requisitePopup = ref<InstanceType<typeof RequisiteFormPopup>|null>(null)
    const templatesPopup = ref<InstanceType<typeof RequisiteTemplatesPopup>|null>(null)
    const counterpartiesModal = ref<InstanceType<typeof CounterpartiesPopup>|null>(null)
    const agreementPopup = ref<InstanceType<typeof BlacklistMethodAgreementPopup>|null>(null)
    const confirmPopup = ref<InstanceType<typeof ConfirmPopup>|null>(null)
    const devicesPopup = ref<InstanceType<typeof DevicesPopup>|null>(null)
    const requisitesGroupsPopup = ref<InstanceType<typeof RequisitesGroupsPopup>|null>(null)
    const deviceLogsPopup = ref<InstanceType<typeof DeviceLogsPopup>|null>(null)
    const limitsPopup = ref<InstanceType<typeof LimitsPopup>|null>(null)
    const fraudexCheckPopup = ref<InstanceType<typeof FraudexCheckPopup>|null>(null)
    const fraudexFeedbackPopup = ref<InstanceType<typeof FraudexFeedbackPopup>|null>(null)
    const bulkEditPopup = ref<InstanceType<typeof RequisitesBulkEditPopup>|null>(null)
    const notification = useNotification()

    const store = useStore()

    const GROUP_BY_PHONE_STORAGE_KEY = 'requisites.groupByPhone'
    const loadGroupByPhonePreference = (): boolean => {
      try {
        return localStorage.getItem(GROUP_BY_PHONE_STORAGE_KEY) === '1'
      } catch (e) {
        return false
      }
    }

    const reorderEnabled = computed(() => !!store.getters.getAppData?.REQUISITES_MANUAL_REORDER_ENABLED)

    const templatesAvailable = computed(() => {
      return !!store.getters.getAppData?.REQUISITES_TEMPLATES_ENABLED && !!store.getters.isTrader
    })

    const bulkEditAvailable = computed(() => {
      return !!store.getters.getAppData?.REQUISITES_BULK_EDIT_ENABLED
        && (store.getters.isTrader || store.getters.isTraderOperator)
    })

    const state = reactive({
      createModal: false,
      payInDealSumsModal: false,
      devicesModal: false,
      groupsModal: false,
      createModalTitle: '',
      fraudexCheckData: null as TraderRequisitesDTO|null,
      fraudexFeedbackRequisite: null as TraderRequisitesDTO|null,
      page: 1,
      requestDTO: {
        id: null,
        ids: [],
        currencies: [],
        traderIds: [],
        methods: [],
        statuses: [],
        options: [],
        query: '',
        deviceId: null,
        groupId: null,
        isDeleted: 'false',
        minAmount: null,
        maxAmount: null,
        storeId: null,
        counterpartyUserId: null,
      } as RequisitesRequestDTO,
      requisites: {
        limit: 50,
        offset: 0,
        totalCount: 0,
        items: []
      } as PaginatedResponseDTO<TraderRequisitesDTO>,
      perPageOptions: [10, 20, 50, 100, 200],
      blacklistMethods: [] as string[],
      traderPlans: [] as any[],
      hasActivePlans: false,
      hasUnfinishedPlans: false,
      groupByPhone: loadGroupByPhonePreference(),
      groups: [] as RequisitesPhoneGroupDTO[],
      expandedGroups: {} as Record<string, boolean>,
      selected: {} as Record<number, boolean>,
    });

    const load = async () => {
      await loader.value?.load(_load);
    }

    const loadTraderPlans = async () => {
      try {
        const user = store.getters.getUser
        if (user && user.id) {
          state.traderPlans = await api.getTraderPlans(user.id)
          state.hasActivePlans = state.traderPlans.some(plan => plan.isActive)
          state.hasUnfinishedPlans = state.traderPlans.some(plan => {
            return !plan.isTimerActive;
          })
        }
      } catch (error) {
        console.error('Error loading trader plans:', error)
        state.traderPlans = []
        state.hasActivePlans = false
        state.hasUnfinishedPlans = false
      }
    }

    const enrichItems = async (items: TraderRequisitesDTO[]) => {
      let traderIds = [];
      let deviceIds = [];
      for (const item of items) {
        traderIds.push(item.traderId)
        if (item.deviceId) {
          deviceIds.push(item.deviceId)
        }
      }

      let groups = {} as Dictionary<TraderRequisiteGroupDTO>;
      let devices = {} as Dictionary<TraderDeviceDTO>;

      const [groupsResponse, devicesResponse] = await Promise.all([
        api.traderRequisiteGroups({offset:0, limit: traderIds.length} as PaginationDTO, {traderIds}),
        api.traderDevices({offset:0, limit: deviceIds.length} as PaginationDTO, {ids: deviceIds})
      ])

      for (const group of groupsResponse.items) {
        groups[group.id.toString()] = group
      }

      for (const device of devicesResponse.items) {
        devices[device.id.toString()] = device
      }

      for (const item of items) {
        if (item.deviceId) {
          item.device = devices[item.deviceId.toString()] ?? null;
        }
        if (item.groupId) {
          item.group = groups[item.groupId!.toString()] ?? null;
        }
        if (item.isWhiteTriangle === undefined || item.isWhiteTriangle === null) {
          item.isWhiteTriangle = false;
        }
      }
    }

    const _loadFlat = async () => {
      const requisites = await api.requisites(state.requisites, reorderEnabled.value ? {sortOrder: 'asc'} : {createdAt: 'desc'}, state.requestDTO)
      await enrichItems(requisites.items)
      state.requisites = requisites
      state.groups = []
    }

    const _loadGrouped = async () => {
      const response = await api.requisitesPhoneGroups(state.requisites, state.requestDTO)
      const allItems = response.items.flatMap(group => group.items)
      await enrichItems(allItems)
      state.groups = response.items.map(group => group.items.length === 1 ? {...group, key: null} : group)
      state.requisites = {
        limit: response.limit,
        offset: response.offset,
        totalCount: response.totalCount,
        items: []
      }
    }

    const _load = async () => {
      state.requisites.offset = state.requisites.limit * (state.page - 1)
      state.selected = {}
      if (state.groupByPhone) {
        await _loadGrouped()
      } else {
        await _loadFlat()
      }
    }

    const onRequisitesReorder = async (event: {oldIndex?: number, newIndex?: number}) => {
      if (event.oldIndex == null || event.newIndex == null || event.oldIndex === event.newIndex) {
        return;
      }

      const items = state.requisites.items.slice();
      const [moved] = items.splice(event.oldIndex, 1);
      if (!moved) {
        return;
      }
      items.splice(event.newIndex, 0, moved);
      state.requisites.items = items;

      try {
        await api.reorderRequisites(items.map((item) => item.id));
      } catch (e) {
        notification.notify({type: 'error', title: helper.trans('requisites.notice.reorder_error')});
        load();
      }
    }

    const isMonthLimitReached = (item: TraderRequisitesDTO) =>  {
      return parseInt(item.monthTradesSum.amount) / parseInt(item.monthTradesSumLimit.amount) >= 0.9
    }

    const isDayLimitReached = (item: TraderRequisitesDTO) =>  {
      return parseInt(item.dayTradesSum.amount) / parseInt(item.dayTradesSumLimit.amount) >= 0.9
    }

    const showEditForm = (item: TraderRequisitesDTO|null = null) => {
      const isBlocked = !!(item && item.isLimitLockedByPlan === true)
      requisitePopup.value?.show(item, state.blacklistMethods, isBlocked);
    }

    const toggleRequisitesActivity = async ($event: any, item: TraderRequisitesDTO) => {
      if ($event.target.checked && (store.getters.isTrader || store.getters.isTraderOperator || store.getters.isTeamLead) && state.blacklistMethods.includes(item.method)) {
        item.isActive = false
        agreementPopup.value?.show(item);
        return;
      }

      try {
        const req = await api.toggleRequisitesActivity(item.id, $event.target.checked ? 'enable' : 'disable')
        item.isActive = req.isActive
      } finally {
      }
    }

    const onBlackListModalUpdated = (e: any) => {
      const item = state.requisites.items.filter(req => req.id === e.id)[0];
      if (item) {
        item.isActive = e.isActive
      }
    }

    const allVisibleItems = computed<TraderRequisitesDTO[]>(() => {
      return state.groupByPhone ? state.groups.flatMap(group => group.items) : state.requisites.items
    })

    const hasFrozenRequisites = computed<boolean>(() => allVisibleItems.value.some(hasFrozenSums))

    const isSelected = (id: number) => !!state.selected[id]

    const toggleSelect = (item: TraderRequisitesDTO, checked: boolean) => {
      if (checked) {
        state.selected[item.id] = true
      } else {
        delete state.selected[item.id]
      }
    }

    const selectGroup = (group: RequisitesPhoneGroupDTO, checked: boolean) => {
      for (const item of group.items) {
        toggleSelect(item, checked)
      }
      if (checked && group.key !== null) {
        state.expandedGroups[group.key] = true
      }
    }

    const selectedCountInGroup = (group: RequisitesPhoneGroupDTO) => {
      return group.items.filter(item => isSelected(item.id)).length
    }

    const isExpanded = (group: RequisitesPhoneGroupDTO) => {
      return group.key !== null && !!state.expandedGroups[group.key]
    }

    const toggleExpand = (group: RequisitesPhoneGroupDTO) => {
      if (group.key === null) {
        return
      }
      state.expandedGroups[group.key] = !state.expandedGroups[group.key]
    }

    const selectedItems = computed<TraderRequisitesDTO[]>(() => {
      return allVisibleItems.value.filter(item => isSelected(item.id))
    })

    const allVisibleSelected = computed(() => {
      return allVisibleItems.value.length > 0 && selectedItems.value.length === allVisibleItems.value.length
    })

    const selectAllVisible = (checked: boolean) => {
      for (const item of allVisibleItems.value) {
        toggleSelect(item, checked)
      }
    }

    const showBulkEdit = () => {
      if (selectedItems.value.length === 0) {
        return
      }
      bulkEditPopup.value?.show(selectedItems.value, state.blacklistMethods)
    }

    const onBulkEdited = async (response: BulkUpdateRequisitesResponseDTO) => {
      const skippedByReason = new Map<string, Set<number>>()
      for (const skip of response.skipped) {
        if (!skippedByReason.has(skip.reason)) {
          skippedByReason.set(skip.reason, new Set())
        }
        skippedByReason.get(skip.reason)!.add(skip.id)
      }

      notification.notify({title: helper.trans('requisites.notice.bulk_updated', {count: response.updated.length})})
      skippedByReason.forEach((ids, reason) => {
        notification.notify({
          title: helper.trans(`requisites.bulk_edit.skip.${reason}`, {count: ids.size}),
          type: 'warn'
        })
      })

      await load()
    }

    const selectedInactiveItems = computed<TraderRequisitesDTO[]>(() => {
      return allVisibleItems.value.filter(item => isSelected(item.id) && !item.isActive)
    })

    const selectedActiveItems = computed<TraderRequisitesDTO[]>(() => {
      return allVisibleItems.value.filter(item => isSelected(item.id) && item.isActive)
    })

    const applyBulkResult = (response: BulkToggleRequisitesResponseDTO) => {
      const updatedById = new Map(response.updated.map(item => [item.id, item]))
      for (const item of allVisibleItems.value) {
        const updated = updatedById.get(item.id)
        if (updated) {
          item.isActive = updated.isActive
        }
      }
      state.selected = {}
      if (response.skippedIds.length > 0) {
        notification.notify({
          title: helper.trans('requisites.notice.bulk_skipped', {count: response.skippedIds.length}),
          type: 'warn'
        })
      }
    }

    const enableSelected = async () => {
      const items = selectedInactiveItems.value
      if (items.length === 0) {
        return
      }

      const hasBlacklisted = items.some(item => {
        return (store.getters.isTrader || store.getters.isTraderOperator || store.getters.isTeamLead)
          && state.blacklistMethods.includes(item.method)
      })
      if (hasBlacklisted) {
        agreementPopup.value?.showForItems(items)
        return
      }

      const response = await api.bulkToggleRequisites('enable', items.map(item => item.id), false)
      applyBulkResult(response)
    }

    const disableSelected = async () => {
      const items = selectedActiveItems.value
      if (items.length === 0) {
        return
      }

      const response = await api.bulkToggleRequisites('disable', items.map(item => item.id))
      applyBulkResult(response)
    }

    const onBulkAgreementUpdated = (response: BulkToggleRequisitesResponseDTO) => {
      applyBulkResult(response)
    }

    const toggleGroupByPhone = async () => {
      state.groupByPhone = !state.groupByPhone
      try {
        localStorage.setItem(GROUP_BY_PHONE_STORAGE_KEY, state.groupByPhone ? '1' : '0')
      } catch (e) {
      }
      state.page = 1
      await load()
    }

    const deleteRequisites = async (item: TraderRequisitesDTO) => {
      confirmPopup.value?.show({
        title: $t('labels.delete_confirm'),
        okTitle: $t('button.delete'),
        onOkClick: async () => {
          await api.deleteRequisites(item.id)
          load()
        }
      })
    }

    const applyFilters = async () => {
      state.page = 1;
      await load()
    }

    const clearFilters = async () => {
      state.page = 1;
      state.requestDTO = {
        id: null,
        ids: [],
        currencies: [],
        statuses: [],
        traderIds: [],
        methods: [],
        query: '',
        isDeleted: 'false',
        options: [],
        groupId: null,
        deviceId: null,
        minAmount: null,
        maxAmount: null,
        storeId: null,
        counterpartyUserId: null,
      }
      await load()
    }

    const showGroups = () => {
      requisitesGroupsPopup.value?.show()
    }

    const showTemplates = () => {
      templatesPopup.value?.show()
    }

    const createTemplate = () => {
      requisitePopup.value?.showTemplate(null)
    }

    const editTemplate = (template: RequisiteTemplateDTO) => {
      requisitePopup.value?.showTemplate(template)
    }

    const onTemplateSaved = () => {
      templatesPopup.value?.reload()
    }

    const showLogs = (device: TraderDeviceDTO) => {
      deviceLogsPopup.value?.show(device)
    }

    const showDevices = () => {
      devicesPopup.value?.show()
    }

    const showLimits = () => {
      const user = store.getters.getUser
      limitsPopup.value?.show(user.id)
    }

    const areLimitsBlocked = (item: TraderRequisitesDTO) => {
      return !!item.isLimitLockedByPlan
    }


    onMounted(async () => {
      state.blacklistMethods = (await api.paymentMethodBlackList());
      try {
        store.dispatch("reqGroups/loadList");
        store.dispatch("devices/loadList");
      } catch (e) {
      }
      await loadTraderPlans();
      load();
    });


    const showCounterpartiesModal = (requisitesId: number) => {
      counterpartiesModal.value?.show(requisitesId)
    }

    const handleFraudexCheckContinue = () => {
      if (state.fraudexCheckData?.id) {
        const existingIndex = state.requisites.items.findIndex(item => item.id === state.fraudexCheckData!.id);
        if (existingIndex !== -1) {
          state.requisites.items[existingIndex] = state.fraudexCheckData;
        }
      }
      state.fraudexCheckData = null;
      requisitePopup.value?.hide();
      load();
    }

    const handleFraudexCheckCancel = () => {
      state.fraudexCheckData = null;
    }

    const showFraudexFeedbackModal = (requisite: TraderRequisitesDTO) => {
      state.fraudexFeedbackRequisite = requisite;
      fraudexFeedbackPopup.value?.show();
    }

    const handleFraudexFeedbackSubmit = async (text: string) => {
      if (!store.getters.getAppData?.fraudexEnabled) {
        return;
      }

      if (!state.fraudexFeedbackRequisite) {
        return;
      }

      try {
        await api.sendFraudexFeedback(state.fraudexFeedbackRequisite.id, text);
        notification.notify({
          title: helper.trans('fraudex.feedback_sent'),
          type: 'success'
        });
        state.fraudexFeedbackRequisite = null;
      } catch (e) {
        helper.handleErrors('fraudexFeedback', e);
      }
    }

    const handleRequisiteUpdated = (resp?: TraderRequisitesDTO) => {
      if (resp?.fraudexCheck && store.getters.getAppData?.fraudexEnabled) {
        state.fraudexCheckData = resp;
        fraudexCheckPopup.value?.show();
      } else {
        requisitePopup.value?.hide();
        load();
      }
    }

    return {
      ...toRefs(state),
      reorderEnabled,
      requisitePopup,
      counterpartiesModal,
      showCounterpartiesModal,
      confirmPopup,
      moment,
      showEditForm,
      isMonthLimitReached,
      isDayLimitReached,
      toggleRequisitesActivity,
      onRequisitesReorder,
      TgNotification,
      onBlackListModalUpdated,
      applyFilters,
      clearFilters,
      deleteRequisites,
      showLogs,
      load,
      showGroups,
      showTemplates,
      createTemplate,
      editTemplate,
      onTemplateSaved,
      templatesPopup,
      templatesAvailable,
      showDevices,
      showLimits,
      deviceLogsPopup,
      limitsPopup,
      fraudexCheckPopup,
      fraudexFeedbackPopup,
      helper,
      loader,
      store,
      numberFormatter,
      hasFrozenSums,
      hasFrozenRequisites,
      sumTitle,
      agreementPopup,
      devicesPopup,
      requisitesGroupsPopup,
      areLimitsBlocked,
      loadTraderPlans,
      currencyList: computed(() => store.getters["currencyMethods/currencies"]),
      methodList: computed(() => store.getters["currencyMethods/methods"]),
      PaymentOption,
      handleFraudexCheckContinue,
      handleFraudexCheckCancel,
      showFraudexFeedbackModal,
      handleFraudexFeedbackSubmit,
      handleRequisiteUpdated,
      vietQrEmvFromRaw,
      qrisEmvFromRaw,
      pixEmvFromRaw,
      truncateVietQrEmvDisplay,
      crossBorderSwift,
      toggleGroupByPhone,
      isSelected,
      toggleSelect,
      selectGroup,
      selectedCountInGroup,
      isExpanded,
      toggleExpand,
      selectedInactiveItems,
      selectedActiveItems,
      enableSelected,
      disableSelected,
      onBulkAgreementUpdated,
      bulkEditAvailable,
      bulkEditPopup,
      selectedItems,
      allVisibleSelected,
      selectAllVisible,
      showBulkEdit,
      onBulkEdited,
    }
  }
})
</script>
<style scoped>
.limits-label {
  position: relative;
  padding-right: 16px;
  display: inline-flex;
  align-items: center;
}
.limits-dot {
  position: absolute;
  top: -2px;
  right: 0;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #dc3545;
  box-shadow: 0 0 0 2px #fff;
  display: inline-block;
  z-index: 1;
}
.requisites-per-page {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.requisites-per-page__select {
  appearance: none;
  background: transparent;
  border: 0;
  padding: 0 18px 0 4px;
  font: inherit;
  color: inherit;
  line-height: 1;
  cursor: pointer;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6' fill='none'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2399A1B7' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 2px center;
}
.requisites-per-page__select:focus {
  outline: none;
}
.requisites-drag-cell {
  width: 44px;
  padding-right: 0 !important;
}
.drag-handle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 40px;
  cursor: grab;
  color: #99A1B7;
}
.drag-handle:active {
  cursor: grabbing;
}
@media (max-width: 768px) {
  table.table__flex tbody td.requisites-drag-cell {
    width: auto !important;
    flex: 0 0 auto;
    align-self: center;
    background: transparent;
    padding: 0 !important;
  }
}
</style>
